import React from 'react'
import ExcelFile from '../components/ExcelFile'

const Carga = () => {

    return(
        <div>
            <br/> 
            <ExcelFile />
            

        </div>
    )
}
export default Carga